import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Spinner from '../components/Spinner';
import TextCard from '../components/TextCard';
import CardsContainer from '../components/CardsContainer';
import SectorChartCard from '../components/SectorChartCard';
import RichListButtons from '../components/RichListButtons';
import Table from '../components/Table';
import { getAllStats } from '../actions/RichListActions.js';
import { getAllTimeSeries } from '../actions/TimeSeriesActions.js';

const HomeScreen = () => {
  const dispatch = useDispatch();

  const richLists = useSelector((state) => state.richLists);
  const { loading, error, lists, stats } = richLists;

  const timeSeries = useSelector((state) => state.timeSeries);
  const {
    loading: loadingTimeSeries,
    error: errorTimeSeries,
    data,
  } = timeSeries;

  useEffect(() => {
    if (lists?.length === 0 || stats?.length === 0) {
      dispatch(getAllStats());
      dispatch(getAllTimeSeries());
    }
  }, [lists?.length, stats?.length, dispatch]);

  return (
    <main role="main">
      <TextCard
        text={"How do you calculate someone's net worth?"}
        linktext={'Find out here'}
        link={'/methodology'}
        main={true}
      />
      {loading || loadingTimeSeries ? (
        <Spinner />
      ) : error || errorTimeSeries ? (
        <div className="flex justify-center ">
          <h1 className="mt-8 p-4 rounded max-w-sm text-center font-mono text-white bg-yellow-600 text-2xl">
            Error. Please refresh
          </h1>
        </div>
      ) : (
        lists?.length & stats?.length & data?.length && (
          <>
            <CardsContainer />
            <SectorChartCard />
            <RichListButtons />
            <Table />
          </>
        )
      )}
    </main>
  );
};

export default HomeScreen;
